import React from 'react';
import classNames from 'classnames';

import { Button } from 'formlabs-web-components/Link';

import './ProgressTracker.module.css';

const ProgressTracker = ({
  currentStep,
  steps,
  twoStep = false,
  back = null
}) => {
  if (steps.length <= 1) {
    return null;
  }
  return (
    <div styleName="progress-tracker">
      <div styleName="">
        {steps.map((step, i) => {
          return (
            <div
              styleName={classNames('step', {
                highlight: i++ === currentStep,
                hover: i <= currentStep,
                passed: i <= currentStep,
                'two-step': twoStep
              })}
              key={step}
            >
              <span styleName="step-dot" />
              <p>
                <Button
                  onClick={() => {
                    if (back) {
                      back(i - 1);
                    }
                  }}
                  styleName={classNames('inherit', {
                    disabled: i > currentStep
                  })}
                  color="inherit-color"
                >
                  {step}
                </Button>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressTracker;
